/*
THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE PAYMENT OPTIONS
*/

import React, { useEffect, useState } from "react";
import "./Payment.css";
import { useSelector, useDispatch } from "react-redux";
import {
  updatePayment,
  setLoading,
  setCheckoutStep,
  setCart,
  setPaymentStatus,
  removeCard,
  setShowError,
  updateCustomer,
} from "../../../actions/actionCreators";
import CartService from "../../../services/CartService";
import PaymentOptionsService from "../../../services/PaymentOptionsService";
import StoreService from "../../../services/StoreService";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Card from "./Card";
import { getCardLogo, getCustomerReport } from "../../../helper/Utility";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import BillingAddress from "../BillingAddress/BillingAddress";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiTypography-body1": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontSize: "1.1rem",
    },
    "& .MuiFormControlLabel-label": {
      display: "flex",
      width: "100%",
    },
  },
  checkBox: {
    "& .MuiTypography-body1": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontWeight: 600,
      fontSize: "1rem",
    },
    "& .MuiFormControlLabel-label": {
      display: "flex",
      width: "100%",
    },
  },
  expanded: {},
  content: {
    margin: 0,
    "&$expanded": {
      margin: "0px 0",
    },
  },
  MuiAccordionroot: {
    "&.MuiAccordion-root:before": {
      height: 0,
      opacity: 0,
    },
  },
}));

const Payment = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cartReducer);
  const front_config = useSelector((state) => state.frontConfigReducer);
  const pickupStore = useSelector(
    (state) => state.shippingMethodReducer.pickupStore
  );
  const mainColor = front_config.color;
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [value, setValue] = useState("OnDelivery");
  const [cardLogo, setCardLogo] = useState("");
  const [temporalToken, setTemporalToken] = useState("");
  const [saveCard, setSaveCard] = useState(false);
  const [saveCardRadioValue, setSaveCardRadioValue] = useState("No");
  const [saveCardModalVisible, setSaveCardVisibility] = useState(false);
  const [cardDisplayNumber, setCardDisplayNumber] = useState("");
  const [selectedCard, setSelectedCard] = useState("");
  const [storeCredentials, setStoreCredentials] = useState(null);
  const [subscribe, setSubscribe] = useState(getSubscribe());

  const paymentSuccessful = useSelector(
    (state) => state.paymentStatusReducer.paymentSuccessful
  );
  const startPaymentProcessing = useSelector(
    (state) => state.paymentStatusReducer.startPaymentProcessing
  );
  const billingAsShipping = useSelector(
    (state) => state.paymentStatusReducer.billingAsShipping
  );
  const checkoutStep = useSelector(
    (state) => state.navigationReducer.checkoutStep
  );
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (
      Array.isArray(cart.customer.customer_tokens) &&
      cart.customer.customer_tokens.length > 0 &&
      cart.customer.customer_tokens[0].display_number
    ) {
      let logo = getCardLogo(cart.customer.customer_tokens[0].brand);

      console.log("useEffect----")
      setCardLogo(logo);
    }
    data();
    if (
      Array.isArray(cart.customer.customer_tokens) &&
      cart.customer.customer_tokens.length > 0 &&
      cart.customer.customer_tokens[0].display_number
    ) {
      setCardDisplayNumber(cart.customer.customer_tokens[0].display_number);
    }
    getCredentials();
  }, []);

  useEffect(() => {
    if (startPaymentProcessing) {
      submitPayment();
    }
  }, [startPaymentProcessing, paymentSuccessful]);

  useEffect(() => {
    postCustomerMarketing();
  }, [cart.customer.accepts_marketing]);


  const data = async () => {
    let paymentOptionsResponse = await PaymentOptionsService.getData(
      cart.token
    );
    setPaymentOptions(paymentOptionsResponse);
    console.log("data---", paymentOptionsResponse)
    if (Array.isArray(cart.customer.customer_tokens) && cart.customer.customer_tokens.length > 0 ){
       setValue('CreditCard');
    }else{
      if (paymentOptionsResponse[0]) {
        let option = paymentOptionsResponse.filter(
          (option) => option.code == "OnDelivery"
        )
          ? "OnDelivery"
          : paymentOptionsResponse[0];
        handleChange(option);
      }
    }
  };

  const handleChange = (selectedOption) => {
    // setValue(selectedOption);
    // let payload = [{ fieldToUpdate: 'option_code', value: selectedOption }];
    // dispatch(updatePayment(payload));

    console.log("--handleChange---", selectedOption)
    if (
      selectedOption == "CreditCard" &&
      front_config.card_payment_gateway === "paysafe" &&
      cardDisplayNumber.length === 0
    ) {
      let billingValid = checkBillingValidity();
      if (billingValid) {
        setValue(selectedOption);
        let payload = [{ fieldToUpdate: "option_code", value: selectedOption }];
        dispatch(updatePayment(payload));
        showSaveCardModal();
      } else {
        dispatch(
          setShowError({
            showError: true,
            errorText: t(
              "Please make sure billing address information is correctly filled out"
            ),
          })
        );
      }
      // checkout()
    } else {
      setValue(selectedOption);
      let payload = [{ fieldToUpdate: "option_code", value: selectedOption }];
      dispatch(updatePayment(payload));
    }
  };

  const submitPayment = async () => {
    dispatch(setLoading(true));
    let billing = billingAsShipping
      ? cart.shipping_address
      : cart.billing_address;
    const updateBillingResponse = await CartService.updateBillingAddress(
      billing,
      cart.token
    );

    console.log("--submitPayment-- option_code:", value)
    if (updateBillingResponse.status === 200 && value === "OnDelivery") {
      // let paymentToken = Array.isArray(cart.customer.customer_tokens) && cart.customer.customer_tokens.length > 0 && cart.customer.customer_tokens[0].credit_card_token ? cart.customer.customer_tokens[0].credit_card_token : '';
      let paymentObj = { option_code: value };
      let response = await CartService.createPayment(paymentObj, cart.token);

      console.log("createPayment response---", response)
      dispatch(setLoading(false));

      if (response.error == null && response.status === 200) {
        let responseCart = await CartService.cartData(cart.token);
        dispatch(setCart(responseCart));
        let newStep = checkoutStep < 4 ? checkoutStep + 1 : checkoutStep;
        dispatch(setCheckoutStep(newStep));
      } else {
        let payload = [
          { fieldToUpdate: "credit_card_temporal_token", value: "" },
        ];
        setTemporalToken("");
        dispatch(updatePayment(payload));
        dispatch(
          setPaymentStatus([
            { fieldToUpdate: "startPaymentProcessing", value: false },
          ])
        );
        dispatch(
          setShowError({
            showError: true,
            errorText: response.json.error.message,
          })
        );
      }
    } else if (updateBillingResponse.status === 200 && value === "CreditCard") {
      let prevCustomerCard = selectedCard;
      let paymentToken =
        temporalToken.length > 0 ? temporalToken : prevCustomerCard;
      let paymentObj = {
        credit_card_temporal_token: paymentToken,
        credit_card_save:
          prevCustomerCard.length > 0 && temporalToken === "" ? true : saveCard,
        option_code: value,
      };
      let response = await CartService.createPayment(paymentObj, cart.token);

      dispatch(setLoading(false));

      if (response.error == null && response.status === 200) {
        let responseCart = await CartService.cartData(cart.token);
        dispatch(setCart(responseCart));
        let newStep = checkoutStep < 4 ? checkoutStep + 1 : checkoutStep;
        dispatch(setCheckoutStep(newStep));
      } else {
        dispatch(
          setShowError({
            showError: true,
            errorText: response.json.error.message,
          })
        );
        let payload = [
          { fieldToUpdate: "credit_card_temporal_token", value: "" },
        ];
        setTemporalToken("");
        dispatch(updatePayment(payload));
        dispatch(
          setPaymentStatus([
            { fieldToUpdate: "startPaymentProcessing", value: false },
          ])
        );
      }
      // window.paysafe.checkout.close();
    } else {
      dispatch(setLoading(false));
    }

    // if (updateBillingResponse.status === 200) {
    //   let response = await CartService.createPayment(cart.payment, cart.token);
    //   dispatch(setLoading(false));

    //   if (response.error == null && response.status === 200) {
    //     let responseCart = await CartService.cartData(cart.token);
    //     dispatch(setCart(responseCart));
    //     let newStep = (checkoutStep < 4) ? checkoutStep+1 : checkoutStep;
    //     dispatch(setCheckoutStep(newStep));
    //   }

    // } else {
    //   dispatch(setLoading(false));
    // }
  };

  return (
    <div className="PaymentContainer">
      <Dialog
        fullWidth
        maxWidth={"sm"}
        open={saveCardModalVisible}
        // onClose={handleClose}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        {/* <DialogTitle id="scroll-dialog-title">
          Save card for future use?
        </DialogTitle>
        <DialogContent dividers={"paper"}>
          <Accordion expanded={false} style={{boxShadow: 'none', margin: 0}}>
            <AccordionSummary
              aria-controls="card-save-radio-group"
              id="card-save-radio-group"
              style={{ minHeight: 25 }}
            >
              <RadioGroup
                aria-label="savecard"
                name="savecard"
                value={saveCardRadioValue}
                onChange={handleSaveCardRadio}
                className={classes.root}
              >
                <FormControlLabel
                  value={"Yes"}
                  key={"Yes"}
                  control={<Radio color="primary" />}
                  label={"Yes"}
                />
                <FormControlLabel
                  value={"No"}
                  key={"No"}
                  control={<Radio color="primary" />}
                  label={"No"}
                />
              </RadioGroup>
            </AccordionSummary>
          </Accordion>
        </DialogContent> */}
        <DialogTitle id="scroll-dialog-title">
          Select Billing Address
        </DialogTitle>
        <DialogContent dividers={"paper"}>
          <BillingAddress />
        </DialogContent>
        <DialogActions>
          <Button onClick={resetSaveCard} color="primary">
            Cancel
          </Button>
          <Button onClick={handlePaymentModal} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <span className="TransactionTxt">
        {t(
          "All transactions are secure and encrypted. Credit card information is never stored."
        )}
      </span>
      <RadioGroup
        aria-label="payment"
        name="payment"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
      >
        {paymentOptions &&
          paymentOptions.map((paymentOption) => (
            <Accordion
              expanded={value === paymentOption.code}
              key={paymentOption.code}
              style={{ boxShadow: "none" }}
              elevation={0}
              classes={{
                root: classes.MuiAccordionroot,
              }}
            >
              <AccordionSummary
                aria-controls="additional-actions1-content"
                id={paymentOption.code}
                classes={{
                  content: classes.content,
                  expanded: classes.expanded,
                }}
                style={{ minHeight: 25 }}
              >
                <FormControlLabel
                  className={classes.root}
                  control={<Radio color="primary" />}
                  label={paymentOption.title}
                  value={paymentOption.code}
                />
                {paymentOption.title.includes("Credit Card") ? (
                  <div className="CreditCardIcons">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 38 24"
                      role="img"
                      width="38"
                      height="24"
                      aria-labelledby="pi-master"
                    >
                      <title id="pi-master">Mastercard</title>
                      <path
                        opacity=".07"
                        d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                      />
                      <path
                        fill="#fff"
                        d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                      />
                      <circle fill="#EB001B" cx="15" cy="12" r="7" />
                      <circle fill="#F79E1B" cx="23" cy="12" r="7" />
                      <path
                        fill="#FF5F00"
                        d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"
                      />
                    </svg>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 38 24"
                      role="img"
                      width="38"
                      height="24"
                      aria-labelledby="pi-visa"
                    >
                      <title id="pi-visa">Visa</title>
                      <path
                        opacity=".07"
                        d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                      />
                      <path
                        fill="#fff"
                        d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                      />
                      <path
                        d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z"
                        fill="#142688"
                      />
                    </svg>
                  </div>
                ) : null}
              </AccordionSummary>
              {cart.customer.customer_tokens &&
              cart.customer.customer_tokens[0] ? (
                <AccordionDetails
                  style={{ flexDirection: "column", padding: "0px" }}
                  className={classes.accordion}
                >
                  <div className="CardHeaderSummary">
                    <div className="YourCardsDiv">
                      <p className="CardHeaderText">Your credit cards</p>
                    </div>
                    <div className="CardNameDiv">
                      <p className="CardHeaderText">Name on card</p>
                    </div>
                    <div className="ExpiryDiv">
                      <p className="CardHeaderText">Expires on</p>
                    </div>
                  </div>

                  <RadioGroup
                    aria-label="cards"
                    name="cards"
                    value={selectedCard}
                    onChange={(e) => handleCardSelection(e.target.value)}
                  >
                    {renderCreditCards()}
                  </RadioGroup>
                  <button
                    onClick={showSaveCardModal}
                    style={{ color: mainColor }}
                    className="AddNewBtn"
                  >
                    Add new card
                  </button>
                </AccordionDetails>
              ) : (
                <AccordionDetails style={{ padding: "0px" }}>
                  <button
                    onClick={showSaveCardModal}
                    style={{ color: mainColor }}
                    className="AddNewBtn"
                  >
                    Add new card
                  </button>
                </AccordionDetails>
              )}
              {paymentOption.code === "CreditCard" &&
              front_config.card_payment_gateway != "paysafe" ? (
                <AccordionDetails style={{ padding: "0px" }}>
                  <Card />
                </AccordionDetails>
              ) : null}
            </Accordion>
          ))}
      </RadioGroup>
      {/* {saveCardModalVisible ? (
        <div className="SaveCardModal">
          <div className="SaveCardBox">
            <button
              style={{ backgroundColor: mainColor }}
              onClick={resetSaveCard}
              className="CloseModalBtn"
            >
              x
            </button>
            <p className="SaveCardPrompt">
              {t("Save card for furture purchases?")}
            </p>
            <div className="SaveCardOptions">
              <button onClick={cardSaved} className="SaveCardBtn">
                {t("Yes")}
              </button>
              <button onClick={cardNotSaved} className="SaveCardBtn">
                {t("No")}
              </button>
            </div>
          </div>
        </div>
      ) : null} */}
      <div className="SubscribeCont">
        <FormControlLabel
          control={
            <Checkbox
              checked={subscribe}
              onChange={toggleSubscribe}
              name="subscribe"
              color="primary"
            />
          }
          label={t("Subscribe for promotions")}
          className={classes.checkBox}
        />
      </div>
    </div>
  );

  function toggleSubscribe(e) {
    setSubscribe(e.target.checked);
    let payload = [
      { fieldToUpdate: "accepts_marketing", value: e.target.checked },
    ];
    dispatch(updateCustomer(payload));
  }

  async function postCustomerMarketing() {
    const customerReport = getCustomerReport(cart.customer);
    const updateResponse = await CartService.updateCustomer(
      customerReport,
      cart.token
    );
  }

  function getSubscribe() {
    if (cart.customer && cart.customer.accepts_marketing) {
      return cart.customer.accepts_marketing;
    } else {
      return false;
    }
  }

  function renderCreditCards() {
    return cart.customer.customer_tokens.map((token, i) => {
      var numb = token.expiry.match(/\d+/g);
      // numb = numb.join("");
      return (
        <FormControlLabel
          className={classes.root}
          control={<Radio color="primary" />}
          // label={token.display_number}
          label={
            <>
              <div className="CardHeaderLabel">
                <button
                  onClick={() => {
                    handleCreditCardRemoval(token.credit_card_token);
                  }}
                  className="RemoveCardBtn"
                >
                  x
                </button>
                <div className="YourCardsLabel">
                  <p className="CardLabelText">
                    {"••••" + token.display_number}
                  </p>
                </div>
                <div className="CardNameLabel">
                  <p className="CardLabelText">{token.name_on_card}</p>
                </div>
                <div className="ExpiryLabel">
                  <p className="CardLabelText">{numb[1] + "/" + numb[0]}</p>
                </div>
              </div>
            </>
          }
          value={token.credit_card_token}
          key={i}
        />
      );
    });
  }

  async function getCredentials() {
    let storeId =
      cart.delivery.pickup && pickupStore.id
        ? pickupStore.id
        : cart.delivery.pickup === false
        ? cart.shipping_address.store.id
        : "error";
    let getCredentialsResponse = await StoreService.getStoreCredentials(
      cart.token,
      storeId
    );

    console.log("---getCredentialsResponse---", getCredentialsResponse)
    if (getCredentialsResponse.token) {
      setStoreCredentials(getCredentialsResponse);
    }
  }

  async function handleCreditCardRemoval(cardToken) {
    let creditCardRemoveResponse = await CartService.removeCreditCard(
      cardToken,
      cart.token
    );
    if (creditCardRemoveResponse.credit_card_token === cardToken) {
      dispatch(
        removeCard({
          credit_card_token: creditCardRemoveResponse.credit_card_token,
        })
      );
    }
  }

  function handleCardSelection(value) {
    console.log("handleCardSelection---", value)
    setSelectedCard(value);
  }

  function showSaveCardModal() {
    setSaveCardVisibility(true);
    // setSaveCardVisibility(true);
    // if (paymentOptions[0] && value !== 'CreditCard') {
    //   let option = paymentOptions.filter(option => option.code == "CreditCard") ? "CreditCard" : paymentOptions[0]
    //   handleChange(option)
    // }
  }

  function hideSaveCardModal() {
    setSaveCardVisibility(false);
  }

  function resetSaveCard(params) {
    setSaveCardVisibility(false);
    if (paymentOptions[0]) {
      let option = paymentOptions.filter(
        (option) => option.code == "OnDelivery"
      )
        ? "OnDelivery"
        : paymentOptions[0];
      handleChange(option);
    }
  }

  function handlePaymentModal() {
    hideSaveCardModal();
    if (storeCredentials !== null) {
      checkout();
    } else {
      dispatch(
        setShowError({
          showError: true,
          errorText:
            "We are experiencing issues with the checkout. Please try again later",
        })
      );
    }
  }

  function handleSaveCardRadio(e) {
    setSaveCardRadioValue(e.target.value);
    if (e.target.value === "Yes") {
      setSaveCard(true);
    } else {
      setSaveCard(false);
    }
  }

  function cardSaved() {
    setSaveCard(true);
    hideSaveCardModal();
    if (storeCredentials !== null) {
      checkout();
    } else {
      dispatch(
        setShowError({
          showError: true,
          errorText:
            "We are experiencing issues with the checkout. Please try again later",
        })
      );
    }
  }

  function cardNotSaved() {
    hideSaveCardModal();
    setSaveCard(false);
    if (storeCredentials !== null) {
      checkout();
    } else {
      dispatch(
        setShowError({
          showError: true,
          errorText:
            "We are experiencing issues with the checkout. Please try again later",
        })
      );
    }
  }

  function checkout() {
    let accountIDNum = parseInt(storeCredentials.account_id);
    dispatch(setLoading(true));

    let checkoutOptions = {
      amount: cart.total_price,
      currency: "CAD",
      // environment: 'LIVE',
      environment: storeCredentials.test === true ? "TEST" : "LIVE",
      companyName: front_config.name,
      billingAddress: paysafeBillingAddres(),
    };
    if (storeCredentials.threeDS_active) {
      checkoutOptions.accounts = { CC: accountIDNum };
      checkoutOptions.shippingAddress = paysafeShippingAddress();
      checkoutOptions.threeDS = {useThreeDSecureVersion2: true};
    }

    window.paysafe.checkout.setup(
      storeCredentials.token,
      checkoutOptions,
      function (instance, error, result) {
        console.log("window.paysafe.checkout.setup----", result)
        if (result && result.token) {
          if (result.paymentMethod == "Cards") {
            let payload = [
              {
                fieldToUpdate: "credit_card_temporal_token",
                value: result.token,
              },
            ];

            console.log("payload----",payload)
            setTemporalToken(result.token);
            dispatch(updatePayment(payload));
            dispatch(
              setPaymentStatus([
                { fieldToUpdate: "startPaymentProcessing", value: true },
              ])
            );
            instance.close();
          }
        } else {
          // error handling
        }
      },
      () => {
        if (paymentOptions[0]) {
          let option = paymentOptions.filter(
            (option) => option.code == "OnDelivery"
          )
            ? "OnDelivery"
            : paymentOptions[0];
          handleChange(option);
        }
        let shouldSave = cardDisplayNumber.length > 0 ? true : false;
        setSaveCard(shouldSave);
        // dispatch(setLoading(false));
      }
    );
  }

  function paysafeBillingAddres() {
    let billing = billingAsShipping
      ? cart.shipping_address
      : cart.billing_address;
    return {
      street: billing.address1,
      city: billing.city,
      state: billing.province_code,
      zip: billing.zip,
      country: billing.country_code,
    };
  }

  function paysafeShippingAddress() {
    return {
      street: cart.shipping_address.address1,
      city: cart.shipping_address.city,
      state: cart.shipping_address.province_code,
      zip: cart.shipping_address.zip,
      country: cart.shipping_address.country_code,
    }
  }

  function checkBillingValidity() {
    let billing = paysafeBillingAddres();
    if (
      billing.street !== "" &&
      billing.city !== "" &&
      billing.state !== "" &&
      billing.zip !== "" &&
      billing.country !== ""
    ) {
      return true;
    } else {
      return false;
    }
  }
};

export default Payment;
